import { padStart } from 'lodash';

export default function formatDate(year: string, month: string, day: string = '01') {
  const monthString = padStart(month, 2, '0');
  const dayString = padStart(day, 2, '0');
  return [year, monthString, dayString].join('-');
}
